<template lang="pug">
div
    template(v-if="cms")
        //- Preview mode we talk to storyblok directly and cannot use any fields that front end service provides
        template(v-if="$storyblok.isPreview && cms.story?.content?.password")
            div(class="container bg-warning-light text-dark my-4 p-4") This content is password protected.
        //- We are not in preview mode so now we can use our custom flag
        template(v-else-if="!$storyblok.isPreview && cms.requiresAuth")
            StoryblokLogin

        Storyblok(
            v-if="cms.story"
            :story="cms.story"
        )

        script(v-if="hasAuthor" type="application/ld+json" v-html="getSchema()")

</template>

<script>
import Storyblok from '@/integrations/storyblok'
import StoryblokLogin from '@/integrations/storyblok/login'
export default {
    components: {
        Storyblok,
        StoryblokLogin,
    },
    async asyncData({ store, route, $storyblok }) {
        await store.dispatch('content/initContentData', { route })
    },
    head() {
        // if we have a story then we are getting the data from storyblok and we should use the meta info from there
        if (this.cms.story) {
            const template = {
                ...(this.cms.story.content.metaTitle && {
                    title: this.cms.story.content.metaTitle,
                }),
                ...(this.cms.story.content.metaDescription && {
                    description: this.cms.story.content.metaDescription,
                }),
            }

            const metas = this.$metaHelpers
                .generateMetas(template, this.$route)
                .setSocialUrl(this.$route.fullPath)

            if (this.cms.story.content.shareImage?.filename)
                metas.setSocialImage(
                    this.$storyblok.getNormalizedAsset(
                        this.cms.story.content.shareImage.filename,
                        1920
                    )?.src
                )

            // Storyblok can set No Index, No Follow
            if (this.cms.story.content.disableSeoIndex === 'true') metas.setIsNoIndex()

            // Array to keep track of styles to hide root level elements
            const style = []

            // Hide header and footer based upon flag
            if (this.cms.story.content.hideHeaderFooter === 'true') {
                style.push({
                    cssText: '#Header, #Footer { display:none; }',
                    type: 'text/css',
                })
            }

            return { ...metas.format(), style }
        }
    },
    computed: {
        cms() {
            return this.$store.state.content.data
        },
        hasAuthor() {
            if (!this.cms.story?.content?.authors?.length > 0) return false
            return true
        },
    },
    mounted() {
        this.$lux.label('CMS Page')
        this.$lux.pageLoading(false)
    },
    methods: {
        getSchema() {
            if (!this.cms.story) return '{}'

            const obj = {
                '@context': 'http://schema.org',
                '@type': 'Article',
                datePublished: this.cms.story.first_published_at,
                dateModified: this.cms.story.published_at,
            }

            if (this.cms.story.content.metaTitle) {
                const meta = this.$metaHelpers
                    .generateMetas({ title: this.cms.story.content.metaTitle }, this.$route)
                    .format()
                obj.headline = meta.title
            }

            if (this.cms.story.content.shareImage?.filename)
                obj.image = this.cms.story.content.shareImage.filename

            if (this.cms.story.content.authors && this.cms.story.content.authors.length > 0) {
                obj.author = []
                this.cms.story.content.authors.forEach((author) => {
                    obj.author.push({
                        '@type': 'Person',
                        name: author.name,
                    })
                })
            }

            return JSON.stringify(obj)
        },
    },
}
</script>
